import CommonRow from '@/pages/dashboard/components/CommonRow';
import CommonCol from '@/pages/dashboard/components/CommonCol';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import MetricCard from '@/pages/dashboard/components/MetricCardItem/MetricCard';
import PlatformCard from '@/pages/dashboard/components/MetricCardItem/PlatformCard';
import KeyMetricTitle from '@/pages/dashboard/components/MetricCardItem/KeyMetricTitle';
import OverallTableCo from '@/pages/dashboard/components/OverallTableCo';
import CommonRankListCo from '@/pages/dashboard/components/CommonRankListCo';
import Refresh from '@/pages/dashboard/components/PageContainer/Refresh';
import RefreshCo from '@/pages/dashboard/components/RefreshCo';
import OperationList from '@/pages/dashboard/components/PageContainer/OperationList';
import MetricsTrendChart from '@/pages/dashboard/components/MetricsTrendChart';
import MetricsCardTrendChart from '@/pages/dashboard/components/MetricsCardTrendChart';
import CommonCheckBox from '@/pages/dashboard/components/CommonCheckBox';
import MetricComponent from '@/pages/dashboard/components/MetricComponent';
import SwitchStateWrap from '@/pages/dashboard/components/SwitchStateWrap';
import VsBenchmark from '@/pages/dashboard/components/MetricCardItem/components/VsBenchmark';
import VsBenchmarkService from '@/pages/dashboard/components/MetricCardItem/components/VsBenchmarkService';
import VsBenchmarkBtn from '@/pages/dashboard/components/MetricCardItem/components/VsBenchmarkBtn';
import KeyMetricBenchmarkPanel from '@/pages/dashboard/components/KeyMetricBenchmarkPanel';
import iFrameRender from '@/pages/dashboard/components/IframeRender';
import MetricInfo from '@/pages/dashboard/components/MetricInfo';
import CommonRangePicker from '@/pages/dashboard/components/CommonRangePicker';
import MarkDownCard from '@/pages/dashboard/components/MarkDownCard';
import CommonTable from '@/pages/dashboard/components/CommonTable';
import EventMetricTrend from '@/pages/dashboard/components/EventMetricTrend';
import SimpleMetricGrid from '@/pages/dashboard/components/MetricCardItem/SimpleMetricGrid';
import MultiViewDimensionCard from '@/pages/dashboard/components/MetricCardItem/MultiViewDimensionCard';
import ServiceSelectorFormat from '@/pages/dashboard/components/ServiceSelectorFormat';
import FilterWrap from '@/pages/dashboard/components/PageContainer/FilterWrap';
import GameSelector from '@/pages/dashboard/components/GameSelector';
import ImageTextSelector from '@home/components/ImageTextSelector';
import FormattedService from '@/pages/dashboard/components/FormattedService';
import RadioSwitch from '@/pages/dashboard/components/RadioSwitch';

export default {
  CommonRow,
  Service,
  CommonCol,
  OverallTableCo,
  MetricCard,
  PlatformCard,
  KeyMetricTitle,
  CommonRankListCo,
  Refresh,
  RefreshCo,
  OperationList,
  MetricsTrendChart,
  MetricsCardTrendChart,
  CommonCheckBox,
  SwitchStateWrap,
  VsBenchmark,
  VsBenchmarkService,
  VsBenchmarkBtn,
  KeyMetricBenchmarkPanel,
  MetricComponent,
  iFrameRender,
  MetricInfo,
  CommonRangePicker,
  MarkDownCard,
  CommonTable,
  EventMetricTrend,
  SimpleMetricGrid,
  MultiViewDimensionCard,
  ServiceSelectorFormat,
  FilterWrap,
  GameSelector,
  ImageTextSelector,
  FormattedService,
  RadioSwitch,
};
